import { render } from "./NewEventModal.vue?vue&type=template&id=d7a5f3ca&ts=true"
import script from "./NewEventModal.vue?vue&type=script&lang=ts"
export * from "./NewEventModal.vue?vue&type=script&lang=ts"

import "./NewEventModal.vue?vue&type=style&index=0&id=d7a5f3ca&lang=scss"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__